import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { FaPowerOff, FaArrowLeft } from 'react-icons/fa';
import { MdOutlineRefresh } from "react-icons/md";
import '../Header/Header.css';
import {useAuth } from '../AuthContext/AuthContext'

function HeaderCampana({Cargarvotaciones}){
    const { dispatch } = useAuth();

    const location = useLocation()
    let history = useHistory(); 

    const { width } = useWindowDimensions();

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
        width,
        height
        };
    }

    
  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return windowDimensions;
  }

  function Loggout(){
    localStorage.clear();
    history.push("/login");
  }

  function back(){
    history.push("/campana");
  }



      

  return (
    <div className='wrap header'>
    {width<500?(
      <div></div>
    ):(
      <></>
      /*<div style={{ backgroundImage: "url(/iconos/Triangulos.png)"}} className="Triangulo"></div>*/
    )}
           
      {location.pathname.includes("candidato")?
      <button className={"button-small back"} onClick={back}><FaArrowLeft/> Regresar</button>
      :
      <div></div>
      }

      <div className='logoContainer'>
      {width<700 && (location.pathname.includes("candidato")||location.pathname.includes("campana"))?( 
          <div>
            <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo-no" alt="Guadalupana"></img>
          </div>
        ):(
          <div>
            <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo" alt="Guadalupana"></img>
          </div>
        )
      }
      </div>
      { (location.pathname!=='/login' && location.pathname!=='/registro' )?
      <div>
        <button className="button-small logout" onClick={Cargarvotaciones}><MdOutlineRefresh/> Actualizar</button>
        <button className={"button-small logout"} onClick={Loggout}><FaPowerOff/>  Salir </button>
      </div>:
      <div></div>
      }
  </div>
  );
};

export default  HeaderCampana;